<template>
  <div class="relative scrollable">
    <p v-if="ebilletsStatus === 1" class="h5n bold center warning m0">Vous n'avez pas d'e-billet en cours de validité.</p>
    <p v-else-if="ebilletsStatus === 2" class="h5n bold center warning m0">Une erreur technique est survenue. Nous faisons notre possible pour résoudre cette erreur rapidement.</p>
    <p v-else-if="ebilletsStatus === 3" class="h5n bold center warning m0">Une erreur technique est survenue. Veuillez réessayer dans quelques minutes.</p>

    <div class="flex flex-wrap">
      <div v-for="billet in ebillets" :key="billet" class="col-12 lg-col-6 inline-block p1">
          <ticket-list-item  :billet="billet"/>      
      </div>
    </div>
  </div>

</template>

<script>
import { inject } from 'vue';
import TicketListItem from './TicketListItem/TicketListItem.vue';

export default {
  components: { TicketListItem },
  setup () {
    const ebillets = inject('ebillets');
    const ebilletsStatus = inject('ebilletsStatus');
    console.log("ebillets from injected in ticketlist.vue", ebillets)
  
    return {
      ebillets,
      ebilletsStatus
    };
  }
};
</script>
